import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment';

@Injectable({
  providedIn: 'root',
})
export class ConsumptionPeriodsApiService {
  private readonly http = inject(HttpClient);

  public getAllPeriodsData({ userUuid }: { userUuid: string }) {
    return this.http.get(`${environment.restEndpoint}/user/${userUuid}/consumption/period`);
  }
}
